__turbopack_context__.v({
  "button": "search-input-module__9KX_1G__button",
  "circular": "search-input-module__9KX_1G__circular",
  "disabled": "search-input-module__9KX_1G__disabled",
  "focused": "search-input-module__9KX_1G__focused",
  "icon": "search-input-module__9KX_1G__icon",
  "input": "search-input-module__9KX_1G__input",
  "large": "search-input-module__9KX_1G__large",
  "medium": "search-input-module__9KX_1G__medium",
  "outline": "search-input-module__9KX_1G__outline",
  "search": "search-input-module__9KX_1G__search",
  "small": "search-input-module__9KX_1G__small",
  "square": "search-input-module__9KX_1G__square",
});
